import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useDonationsStore } from '../store/donationsStore'
import { addDonation } from '../utils/addDonation'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useAddDonationMutation = (onSuccess?: () => void) => {
  const add = useDonationsStore((state) => state.add)

  return useMutation({
    mutationFn: addDonation,
    onSuccess: ({ message, donation }) => {
      add(donation)
      toast.success(message || 'Donation created successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while creating donation.')
    },
  })
}
